import { ReportMailScheduleTypes } from "../api/dtos";

export const getScheduleString = (type?: ReportMailScheduleTypes) => {
    switch(type) {
        case ReportMailScheduleTypes.Daily:
            return "Daily";
        case ReportMailScheduleTypes.Weekly:
            return "Weekly";
        case ReportMailScheduleTypes.Monthly:
            return "Monthly";
        case ReportMailScheduleTypes.Yearly:
            return "Yearly";
        default:
            return "Never";
    }
}
